function ErrorPage() {
    return (
        <div>
            404 Not Found
        </div>
    )
}

export default ErrorPage